import getBrandLogo from '../../helpers/getBrandLogo';
import { COLORS } from '../../../constants/styles';

const config = {
  logo: 'flagler-logo',
  logoPath: getBrandLogo(),
  logoSize: 44,
  name: 'Flagler Health+ Anywhere',
  welcomeText: 'Already have an account?',
  fillColor: COLORS.blueBrighten,
  registrationLinkTitle: 'auth.haveAccount.text',
  phoneNumber: 9048194475,
  email: 'appsupport@flaglerhealth.org',
  poweredByLogo: true,
};

export default config;



// WEBPACK FOOTER //
// ./src/whitelabel/configs/flagler/index.js